import React, { Component } from "react";
import PropTypes from "prop-types";

class RevealInput extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: props.active,
		};
	}

	render() {
		const { children, label } = this.props;
		const { active } = this.state;

		return (
			<div>
				{active ? (
					children
				) : (
					<button
						className="btn btn-link text-uppercase pl-0 mb-4"
						type="button"
						onClick={() => this.setState({ active: true })}
					>
						{label}
					</button>
				)}
			</div>
		);
	}
}

RevealInput.propTypes = {
	children: PropTypes.node.isRequired,
	label: PropTypes.string.isRequired,
	active: PropTypes.bool,
};

export default RevealInput;
